import clsx from 'clsx';
import React, { FC } from 'react';
import { ArrowDownOutline, ArrowUpOutline } from 'react-ionicons';

interface ArrowsProps {
  scrollDirection: 'up' | 'down';
  handleArrowClick: () => void;
  className?: string;
}

const Arrows: FC<ArrowsProps> = ({
  handleArrowClick,
  scrollDirection,
  className,
}) => {
  return (
    <div
      className={clsx(
        'absolute flex transform justify-center',
        'left-1/2 -translate-x-1/2',
        {
          'bottom-0': scrollDirection === 'down',
          'top-0': scrollDirection === 'up',
        },
        className,
      )}
    >
      <div
        className="from-gray-300 shadow-gray-400/50 flex h-6 w-6 cursor-pointer items-center justify-center rounded-full bg-background-base-surface-1 to-white shadow-elevation4 transition hover:scale-110"
        onClick={handleArrowClick}
      >
        {scrollDirection === 'down' ? (
          <ArrowDownOutline width="15px" height="15px" color="currentColor" />
        ) : (
          <ArrowUpOutline width="15px" height="15px" color="currentColor" />
        )}
      </div>
    </div>
  );
};

export default Arrows;
